// @avantia common-code
import { ensureDefined } from '@avantia/client-and-server-utilities';
import { HpClientDebugFlags } from '../clientDebugFlags';
import { logWarning } from '../clientLogging';
import { HpClientEngineConfiguration, HpRegisterConfigurationActionFunc } from './configurationTypes';

let cachedConfig: HpClientEngineConfiguration | undefined;
let configRegistrations: HpRegisterConfigurationActionFunc[] = [];
let areRegistrationsCleared = false;

export function registerClientConfig(config: HpClientEngineConfiguration): void {
  cachedConfig = ensureDefined(config, 'config');

  if (configRegistrations.length > 0) {
    const registrations = [...configRegistrations];
    if (config.environment !== 'unit-tests') {
      // prevent more than one call to each registration function.
      configRegistrations = [];
      areRegistrationsCleared = true;
    }

    registrations.forEach((action) => action(config));
  } else if (areRegistrationsCleared) {
    logWarning(
      "Calling 'registerClientConfig' more than once does nothing and should not occur outside of unit testing.",
      HpClientDebugFlags.None
    );
  }
}

/**
 * This allows setup actions that need configuration to be processed when the config is initialized.
 * Otherwise we can end up with race conditions.
 * @param action the action to perform using the configuration.
 */
export function registerConfigurationAction(action: HpRegisterConfigurationActionFunc): void {
  if (cachedConfig) {
    action(cachedConfig);
  } else {
    configRegistrations.push(action);
  }
}
